export default {
    calendarView: null,
    calendarViews: [],
    sharedCalendarViews: [],
};
